import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoachGroupsListScreenComponent} from "./screen/coach-groups-list-screen.component";
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/coach-groups-list.reducer";
import {EffectsModule} from "@ngrx/effects";
import {CoachGroupsListEffects} from "./core/coach-groups-list.effects";
import { CoachGroupsListTableComponent } from './components/coach-groups-list-table/coach-groups-list-table.component';
import { CoachGroupsListFilterComponent } from './components/coach-groups-list-filter/coach-groups-list-filter.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { DownloadAttendanceReportModalComponent } from './components/download-attendance-report-modal/download-attendance-report-modal.component';

@NgModule({
  declarations: [
    CoachGroupsListScreenComponent,
    CoachGroupsListTableComponent,
    CoachGroupsListFilterComponent,
    DownloadAttendanceReportModalComponent
  ],
  exports: [
    CoachGroupsListTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.coach-groups-list', reducer),
    EffectsModule.forFeature(
      [CoachGroupsListEffects]
    ),
    InfiniteScrollModule,
  ]
})
export class CoachGroupsListModule {
}
